import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { startGoogleLogin } from "@/components/Navbar";
import { Search, Sparkles, MessageSquare, ClipboardList, Inbox, TrendingUp } from "lucide-react";

const homeowner = [
  { icon: Search, t: "Submit your request", d: "Tell us your service, property, and timeline in under 60 seconds." },
  { icon: Sparkles, t: "Get matched instantly", d: "We route your request to verified local pros in the Sacramento area." },
  { icon: MessageSquare, t: "Compare quotes", d: "Pros reach out with quotes. Compare reviews and pick your favorite." },
];
const pro = [
  { icon: ClipboardList, t: "Create your profile", d: "Sign up with Google, build your verified business listing." },
  { icon: Inbox, t: "Receive local leads", d: "Get matched with exclusive homeowner requests in your service area." },
  { icon: TrendingUp, t: "Claim & grow", d: "Use credits to unlock contact details and win the job. No bidding wars." },
];

export default function HowItWorks() {
  const [tab, setTab] = useState("homeowner");
  const nav = useNavigate();
  const steps = tab === "homeowner" ? homeowner : pro;
  return (
    <div className="container-x py-14">
      <div className="text-center mb-10">
        <h1 className="font-display text-4xl lg:text-5xl font-extrabold text-[color:var(--navy)]">How InspectorProLeads works</h1>
        <p className="text-[color:var(--ink-2)] mt-3">Simple for homeowners. Powerful for local pros.</p>
      </div>
      <div className="flex justify-center gap-2 mb-14">
        <button onClick={() => setTab("homeowner")} data-testid="how-tab-homeowner"
          className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-colors ${tab === "homeowner" ? "btn-primary" : "bg-[color:var(--bg-3)] text-[color:var(--ink-2)]"}`}>For Homeowners</button>
        <button onClick={() => setTab("pro")} data-testid="how-tab-pro"
          className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-colors ${tab === "pro" ? "btn-amber" : "bg-[color:var(--bg-3)] text-[color:var(--ink-2)]"}`}>For Local Pros</button>
      </div>
      <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {steps.map((s, i) => (
          <div key={s.t} className="card-soft p-8 fade-up" style={{ animationDelay: `${i * 80}ms` }}>
            <div className="w-12 h-12 rounded-xl bg-[color:var(--bg-3)] grid place-items-center mb-4"><s.icon className="w-6 h-6 text-[color:var(--emerald)]" /></div>
            <div className="font-mono text-sm text-[color:var(--ink-3)]">STEP {i + 1}</div>
            <h3 className="font-display text-xl font-bold text-[color:var(--navy)] mt-1">{s.t}</h3>
            <p className="text-[color:var(--ink-2)] mt-2">{s.d}</p>
          </div>
        ))}
      </div>
      <div className="text-center mt-14">
        {tab === "homeowner" ? (
          <Button onClick={() => nav("/quote")} className="btn-amber rounded-full px-8 font-semibold" data-testid="how-cta-quote">Request a Free Quote</Button>
        ) : (
          <Button onClick={() => nav("/pricing")} className="btn-primary rounded-full px-8 font-semibold" data-testid="how-cta-join">View Membership Plans</Button>
        )}
      </div>
    </div>
  );
}
